// extracted by mini-css-extract-plugin
export default {"planned_labor_row":"labor-costs-tab_planned_labor_row__6XK78","planned_labor_row__edit_btn":"labor-costs-tab_planned_labor_row__edit_btn__IQzPf"};